import { observer } from 'mobx-react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

import { useQuery } from '../models/reactUtils'

const AcceptsOnlineBookingFilter = observer(() => {
  const { store } = useQuery()
  const { t } = useTranslation()
  const theme = useTheme()
  const mobile = useMediaQuery(theme.breakpoints.down('md'))

  if (!store.searchStore.acceptsOnlineBookingFilterEnabled) {
    return null
  }

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={store.searchStore.acceptsOnlineBooking}
          onChange={event =>
            store.searchStore.setAcceptsOnlineBooking(event.target.checked)
          }
          inputProps={{ 'aria-label': 'Accepting Online Booking Filter' }}
          size="small"
          sx={{ p: 0.5, color: 'secondary.main' }}
        />
      }
      label={t('Accepting Online Booking')}
      sx={{
        m: 0,
        py: '4px',
        pl: '4px',
        pr: '10px',
        color: 'secondary.main',
        background: '#FFF',
        borderRadius: '8px',
        border: mobile ? 1 : 0,
        boxShadow: mobile ? 0 : 3,
        whiteSpace: 'nowrap',
        '& .MuiFormControlLabel-label': {
          fontSize: '0.9rem',
          fontWeight: 500,
        },
      }}
    />
  )
})

AcceptsOnlineBookingFilter.displayName = 'AcceptsOnlineBookingFilter'

export default AcceptsOnlineBookingFilter
